import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../../../core/modules/shared.module';

import { ReportesComponent } from './Reportes.component';
import { ReportesDatosBasicosComponent } from './ReportesDatosBasicos.component';
import { ReporteInformeUsuariosComponent } from './ReporteInformeUsuarios.component';
import { ReporteExitoComponent } from './ReporteExito.component';
import { ReporteExitoInternoComponent } from './ReporteExitoInterno.component';
import { RoleGuardService as RoleGuard } from './../Seguridad/role-guard.service';




const routes = [
    {
        path     : 'Reportes',
        component: ReportesComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'Reportes',
          nombreFormulario : 'Reportes'
        } 
    },
    {
        path     : 'ReportesDatosBasicos',
        component: ReportesDatosBasicosComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'ReportesDatosBasicos',
          nombreFormulario : 'ReportesDatosBasicos'
        } 
    },
    {
        path     : 'ReporteInformeUsuarios',
        component: ReporteInformeUsuariosComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'ReporteInformeUsuarios',
          nombreFormulario : 'ReporteInformeUsuarios'
        } 
    },
    {
        path     : 'ReporteExito',
        component: ReporteExitoComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'ReporteExito',
          nombreFormulario : 'ReporteExito'
        } 
    },
    
    {
        path     : 'ReporteExitoInterno',
        component: ReporteExitoInternoComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'ReporteExitoInterno',
          nombreFormulario : 'ReporteExitoInterno'
        } 
    }
];
   

@NgModule({
    declarations: [
        ReportesComponent,
        ReportesDatosBasicosComponent,
        ReporteInformeUsuariosComponent,
        ReporteExitoComponent,
        ReporteExitoInternoComponent
    ],
    imports     : [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    exports     : [
        ReportesComponent,
        ReportesDatosBasicosComponent,
        ReporteInformeUsuariosComponent,
        ReporteExitoComponent,
        ReporteExitoInternoComponent
        
    ]
})

export class ReportesModule
{
}
















// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/Reportes/Reportes.module.ts